import React from "react";
import { backarrow, headerBg, logo, logout } from "../assets";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { clearUser } from "../redux/userSlice";
import toast from "react-hot-toast";

const Header = ({ page }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const goBack = () => {
    navigate("/admin");
  };
  const logoutFun = () => {
    dispatch(clearUser());
    navigate("/");
    toast.success("Logged out!")
  };
  return (
    <div className="header fixed lg:-z-20 overflow-hidden lg:relative top-0 z-20">
      <img
        src={headerBg}
        className="w-full object-cover object-left-bottom h-16 lg:h-36"
        alt=""
      />
      <div className="absolute top-8 z-20 flex justify-center w-full items-center">
        <div className=" absolute lg:start-16 start-4 text-white text-xl flex items-center gap-4">
          <img src={backarrow} onClick={goBack} className=" cursor-pointer z-50" alt="icon" />
          <p>{page}</p>
        </div>
        <div className="hidden lg:block">
          <img src={logo} alt="logo" className=" h-16" />
        </div>
        <div className="lg:hidden absolute end-6">
          <img src={logout} onClick={logoutFun} alt="logout" />
        </div>
      </div>
    </div>
  );
};

export default Header;
